import styled from 'styled-components';

export const Base = styled.div`
	height: 100vh;
	height: 100svh;
	width: -webkit-fill-available;
	width: -moz-available;
	width: stretch;
	position: absolute;
	background: ${(p) => p.theme.white};
	overflow-x: hidden;
	display: flex;
	flex-direction: column;
	line-height: 160%;
`;

export const SidebarToggle = styled.div`
	position: absolute;
	top: 10px;
	left: 10px;
	z-index: 1;
`;

export const Container = styled.div`
	position: relative;
	width: 100%;
	padding: 48px;
	flex: 1;
	overflow-y: auto;
	box-sizing: border-box;
`;

export const Content = styled.div`
	max-width: 1200px;
	margin: 0 auto;
`;

export const Section = styled.section`
	margin-bottom: 48px;
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 24px;
`;

export const SectionTitle = styled.h2`
	font-size: 20px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[1000]};
	margin: 0;
`;

export const CreditDashboard = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 24px;
	padding-bottom: 60px;
	padding-top: 12px;

	@media (max-width: 1024px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const SubscriptionSection = styled.div`
	margin-bottom: 48px;
`;

export const BillingBanner = styled.div`
	background: ${(p) => p.theme.white};
	border-radius: 12px;
	padding: 24px 12px 12px 12px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	text-align: center;
	border: 1px solid ${(p) => p.theme.gray[200]};
`;

export const TierCards = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 24px;
	margin-bottom: 0;
	margin-top: 32px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const PricingLinkWrapper = styled.div`
	text-align: center;
	margin-bottom: 48px;
`;

export const PricingLink = styled.a`
	display: inline-block;
	color: ${(p) => p.theme.blue[500]};
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	margin-top: 24px;
	transition: color 0.2s ease-in-out;

	&:hover {
		color: ${(p) => p.theme.blue[600]};
	}
`;
